<div class="error-retry">
  <div>{{ text }}</div>
  @if (icon) {
    <div>
      <ftr-icon icon="ErrorCircleSolid" size="Max" color="GreyLighter"></ftr-icon>
    </div>
  }
  <div><button ftrButton displayType="text" (click)="onRetry()">Try again</button></div>
</div>
